import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

export function useBudgetQuery(isEnabled: boolean) {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useQuery<ClientBudget | null>({
    queryKey: ['budget'],
    queryFn: async () => {
      try {
        const res = await fetchData('/client/budget/info');
        return res ?? null;
      } catch (e) {
        error('[useBudgetQuery][GET /client/budget/info]', e);
        showError();
      }
    },
    enabled: isEnabled,
  });
}

export function useBudgetPSDQuery(isEnabled: boolean) {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useQuery<ClientBudget | null>({
    queryKey: ['budgetPsd'],
    queryFn: async () => {
      try {
        const res = await fetchData('/client/budget/psd');
        return res ?? null;
      } catch (e) {
        error('[useBudgetPSDQuery][GET /client/budget/psd]', e);
        showError();
      }
    },
    enabled: isEnabled,
  });
}

export function useBudgetMutation() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useMutation({
    mutationFn: async (body: ClientBudget) => {
      try {
        return await fetchData('/client/budget', {
          method: 'post',
          body: JSON.stringify(body),
        });
      } catch (e) {
        error('[useBudgetMutation][POST /client/budget]', e);
        showError();
        throw e;
      }
    },
  });
}

export type ClientBudget = {
  monthlyIncome: number;
  monthlyExpenses: number;
  numberOfEmployedHouseholdMembers: number;
  numberOfHouseholdMembers: number;
};
